module.exports = __webpack_public_path__ + "img/LP_White_no_text.bcd63780.svg";